const selectors = {
  remainingBudgetList: (state) => state.payment.remainingBudgetList,
  avgUsage: (state) => state.payment.avgUsage.data,
  paymentHistory: (state) => state.payment.paymentHistory.data,
};

export default selectors;
